import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import VistaPrevia from "./VistaPrevia";
import CssBaseline from "@mui/material/CssBaseline";
import { Backdrop, CircularProgress, Grid2, Stack, Typography } from "@mui/material";

const live_events_service = require('../../helpers/live_events_service')

export default function ViewPrograma() {
  const [programa, setPrograma] = useState(null);
  const [loading, setLoading] = useState(true);
  const [contador] = useState(0)
  useEffect(() => {
    live_events_service.getData('/programa/view/' + process.env.REACT_APP_EVT).then((response) => {
      setPrograma(response.data.response_database)
      setLoading(false)
    }).catch((error) => {
      console.log(error)
    })
  }, [contador])
  return (
    <React.Fragment>
      <CssBaseline />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Box sx={{ width: "100%" }} paddingTop={5} paddingBottom={5}>
        <VistaPrevia programa={programa} hash={process.env.REACT_APP_EVT} speaker={false} />
      </Box>
    </React.Fragment>
  );
}
